import { render } from "./FileSizeMaximum.vue?vue&type=template&id=8b482cc2"
import script from "./FileSizeMaximum.vue?vue&type=script&lang=js"
export * from "./FileSizeMaximum.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "8b482cc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b482cc2', script)) {
    api.reload('8b482cc2', script)
  }
  
  module.hot.accept("./FileSizeMaximum.vue?vue&type=template&id=8b482cc2", () => {
    api.rerender('8b482cc2', render)
  })

}

script.__file = "resources/js/Pages/Media/FileSizeMaximum.vue"

export default script